import React from "react";
import { Loader } from "@mantine/core";
import "./Spinner.scss"; // Ensure you have the correct path to your styles

const Spinner: React.FC = () => {
  return (
    <div className="spinner-loading-wrapper">
      <Loader size="md" />
    </div>
  );
};

export default Spinner;
